


import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, Link } from "react-router-dom";
import RequestEditionForm from "../components/RequestEDITIONForm";

import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const EditionArticles = () => {
  const { id } = useParams(); // Get edition ID from the URL
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [nextPage, setNextPage] = useState(null);
  const [loadingMore, setLoadingMore] = useState(false);
  const [showForm, setShowForm] = useState(false); // Track the form visibility

  const [editionDetails, setEditionDetails] = useState(null); // Store edition details (e.g., editor's desk)

  useEffect(() => {
    const fetchEditionDetails = async () => {
      try {
        // const response = await axios.get(`http://127.0.0.1:8000/api/editions/${id}/`);
        const response = await axios.get(`https://api.bppreview.org/api/editions/${id}/`);
        setEditionDetails(response.data); // Save edition details
        setArticles(response.data.articles); // Save articles
        setNextPage(response.data.next); // If paginated
      } catch (err) {
        setError("Failed to fetch edition details. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchEditionDetails();
  }, [id]);

  const loadMoreArticles = async () => {
    if (!nextPage) return;
    setLoadingMore(true);
    try {
      const response = await axios.get(nextPage);
      setArticles((prevArticles) => [...prevArticles, ...(response.data.results || [])]);
      setNextPage(response.data.next);
    } catch (err) {
      setError("Failed to load more articles.");
    } finally {
      setLoadingMore(false);
    }
  };

  // if (loading) return <p>Loading...</p>;
  if (loading) {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 mt-28">
        {Array(6)
          .fill(0)
          .map((_, index) => (
            <div key={index} className="bg-white rounded-lg shadow-md p-4">
              <Skeleton height={160} />
              <div className="p-4">
                <Skeleton height={20} width="70%" />
                <Skeleton height={15} width="50%" className="mt-2" />
                <Skeleton height={30} width="100%" className="mt-4" />
              </div>
            </div>
          ))}
      </div>
    );
  }
  if (error) return <p>{error}</p>;
  const handleSuccess = () => {
    // Optionally handle success, like hiding the form or showing a success message
    setShowForm(false);
  };

  return (
    <div className="container mx-auto p-4 mt-16">
      <h1 className="text-2xl font-bold mb-6 mt-6">Articles for {editionDetails.name}</h1>

      {/* Display Editor's Desk
      {editionDetails?.editors_desk_speech && (
        <div className="mb-6 bg-blue-50 p-4 rounded-lg shadow-md">
          <h2 className="text-xl font-semibold mb-2">Editor's Desk</h2>
          <p className="text-gray-700">{editionDetails.editors_desk_speech}</p>
          <p
            className="text-gray-700"
            dangerouslySetInnerHTML={{ editionDetails.editors_desk_speech || "No description available." }}
          ></p>
        </div>
      )} */}

      {/* Display Editor's Desk */}
      {editionDetails?.editors_desk_speech ? (
        <div className="mb-6 bg-[#e9cea2] p-4 rounded-lg shadow-md">
          <h2 className="text-xl font-semibold mb-2">Editor's Desk</h2>
          {/* Render with dangerouslySetInnerHTML */}
          <p
            className="text-gray-700"
            dangerouslySetInnerHTML={{
              __html: editionDetails.editors_desk_speech,
            }}
          ></p>
        </div>
      ) : (
        <div className="mb-6 bg-b p-4 rounded-lg shadow-md">
          <h2 className="text-xl font-semibold mb-2">Editor's Desk</h2>
          <p className="text-gray-700">No description available.</p>
        </div>
      )}

      {/* Button to toggle the form visibility */}
       {!showForm && (
         <button
           onClick={() => setShowForm(true)}
           className="bg-[#b3976b] text-white px-4 py-2 rounded-full"
         >
           Request Edition
         </button>
       )}

       {showForm && (
         <RequestEditionForm editionId={id} onSuccess={handleSuccess} />
       )}


      {/* Display Articles */}
      {Array.isArray(articles) && articles.length === 0 ? (
        <p className="text-center text-gray-500">No articles available for this edition.</p>
      ) : (
        <div className="mt-6">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
            {Array.isArray(articles) &&
              articles.map((article) => (
                <div key={article.id} className="bg-white rounded-lg shadow-md p-4">
                  <div className="h-40 bg-gray-100 rounded-t-lg">
                    {article.image ? (
                      <LazyLoadImage src={article.image} alt={article.title} className="w-full h-full object-cover" />
                    ) : (
                      <span className="text-gray-400 flex items-center justify-center h-full">Image Placeholder</span>
                    )}
                  </div>
                  <div className="p-4">
                    <h2 className="text-lg font-semibold text-gray-700">{article.title}</h2>
                    <p className="text-sm text-gray-500">{article.industry_display  || "No description available."}</p>
                    <Link
                      to={`/articles/${article.id}`}
                      className="text-blue-500 hover:text-blue-700"
                    >
                      View Article Details
                    </Link>
                  </div>
                </div>
              ))}
          </div>
          {nextPage && (
            <div className="text-center mt-6">
              <button
                onClick={loadMoreArticles}
                className="px-6 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
                disabled={loadingMore}
              >
                {loadingMore ? "Loading..." : "Load More Articles"}
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default EditionArticles;
